import {
  Integration_Handler_Names_Enum,
  Integration_Names_Enum,
  Integration_Service_Names_Enum,
} from '@main/graphql/types.generated';
import { TFunction } from 'i18next';
import z from 'zod/v4';

import { IntegrationSelector } from './integration-selector';
import { generateSchemaDocumentation } from './schema-documentation';

export type GenerateHandlerDocumentationInput = {
  t: TFunction<'integrations'>;
  providerName: Integration_Names_Enum;
  serviceName: Integration_Service_Names_Enum;
  handlerName: Integration_Handler_Names_Enum;
  schema: z.ZodObject;
};

export function generateHandlerDocumentation({
  t,
  providerName,
  serviceName,
  handlerName,
  schema,
}: GenerateHandlerDocumentationInput): string {
  const providerTKey = `integrations.${providerName}`;
  const serviceTKey = `${providerTKey}.services.${serviceName}`;
  const handlerTKey = `${serviceTKey}.handlers.${handlerName}`;
  const tKey = `${handlerTKey}.config`;

  const providerLabel = t(`${providerTKey}.name`, {
    defaultValue: providerName,
  });
  const serviceLabel = t(`${serviceTKey}.name`, {
    defaultValue: serviceName,
  });
  const handlerLabel = t(`${handlerTKey}.name`, { defaultValue: handlerName });
  const descriptionLabel = t(`${handlerTKey}.description`, { defaultValue: handlerName });
  const docs =
    generateCustomDocumentation({ providerName, serviceName, handlerName }) ??
    generateSchemaDocumentation(t, tKey, schema);

  return `# Integration Handler
- Provider: ${providerLabel}
- Service: ${serviceLabel}
- Handler: ${handlerLabel}

${descriptionLabel}

# Config

${docs}`.trim();
}

function generateCustomDocumentation({
  providerName,
  serviceName,
  handlerName,
}: IntegrationSelector) {
  if (
    providerName === Integration_Names_Enum.Sharepoint &&
    serviceName === Integration_Service_Names_Enum.Sharepoint &&
    handlerName === Integration_Handler_Names_Enum.FileSync
  ) {
    return `## File share link
A share link to the file in the SharePoint site.
Instructions on how to obtain a share link are available on the [Complyance Support page](https://support.complyance.com/hc/en-us/articles/34802058677649-How-to-configure-the-SharePoint-integration-for-evidence-generation#01JT0V4M8DMVV56CZS6GX04AVX).`;
  }
  return null;
}
